import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "./Reveal";

const FAQS = [
  {
    q: "Cos'è ValutaGenio?",
    a: "ValutaGenio è una piattaforma italiana che mette a disposizione dei proprietari di casa tre strumenti gratuiti: OrizzontiPro (chiarisce la direzione del progetto), ValutaPro (comprende il potenziale dell'immobile) e PartenzaPro (verifica la preparazione). Puoi utilizzare un singolo strumento oppure completare l'intero percorso.",
  },
  {
    q: "Devo per forza utilizzarli tutti e tre?",
    a: "No. Ogni strumento è indipendente e risponde a una domanda diversa. Puoi utilizzare soltanto ciò che ti serve oggi. Completando il percorso costruisci un quadro più utile per te e per un eventuale confronto con il Property Advisor.",
  },
  {
    q: "Dove ricevo l'analisi?",
    a: "Ogni analisi completa arriva nella tua email. Sullo schermo, al termine di ogni strumento, trovi una sintesi concreta con i punti chiave emersi e il passaggio successivo consigliato. Il contenuto approfondito è nell'email.",
  },
  {
    q: "OrizzontiPro è disponibile?",
    a: "Sì. OrizzontiPro è già disponibile ed è il primo strumento consigliato del percorso: parte da ciò che vuoi ottenere, dai tempi e dai vincoli per restituirti una prima lettura dello scenario.",
  },
  {
    q: "Sarò contattato automaticamente da un Property Advisor?",
    a: "No. Nessuna telefonata parte senza una tua richiesta esplicita. Il Property Advisor entra nella conversazione solo quando lo scegli tu, direttamente dallo strumento oppure rispondendo all'email che hai ricevuto.",
  },
  {
    q: "Il confronto con il Property Advisor è gratuito?",
    a: "Sì. Il primo confronto di orientamento è gratuito e non comporta incarichi o impegni commerciali. Eventuali servizi professionali (mediazione, consulenza legale, verifiche tecniche, incarichi) sono separati e vengono proposti e accettati distintamente.",
  },
  {
    q: "Chi sono i Property Advisor ValutaGenio?",
    a: "I Property Advisor sono professionisti indipendenti del settore immobiliare presenti sulla piattaforma ValutaGenio.\n\nQuando richiedi un confronto, ValutaGenio può metterti in contatto con un professionista che parte dalle informazioni e dalle analisi che hai già completato, evitando di ricominciare da zero.\n\nIl percorso ValutaGenio per il proprietario è gratuito. L'eventuale rapporto professionale o commerciale che potrà nascere successivamente sarà direttamente tra te e il professionista, sulla base delle sue qualifiche, dei servizi offerti e delle condizioni che concorderete.",
  },
  {
    q: "L'analisi di ValutaPro è una perizia?",
    a: "No. ValutaPro fornisce un'indicazione basata sui fattori dichiarati e sulla zona. Non è una perizia estimativa né un documento con valore legale. Serve a farti capire il potenziale e a inquadrare le variabili che incidono di più.",
  },
  {
    q: "I miei dati sono al sicuro?",
    a: "Sì. I tuoi dati sono trattati in conformità al GDPR e non vengono ceduti a terzi senza il tuo consenso esplicito. Il Property Advisor associato al referral riceve le informazioni necessarie a preparare il confronto quando lo richiedi tu.",
  },
  {
    q: "Quanto tempo richiedono le analisi?",
    a: "Ogni strumento è pensato per essere completato in pochi minuti. OrizzontiPro richiede il tempo di raccontare la tua situazione; ValutaPro e PartenzaPro sono guidati da domande brevi. In tutti i casi, l'analisi completa arriva subito dopo via email.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-[#F5F5F5] py-20 md:py-28"
    >
      <div className="max-w-[860px] mx-auto px-6 md:px-8">
        <Reveal className="text-center">
          <span className="inline-block text-xs uppercase tracking-[0.2em] font-semibold text-[#B40101] mb-4">
            FAQ
          </span>
          <h2 className="font-display font-bold text-[#0A0A0A] text-4xl md:text-5xl tracking-tight">
            Domande frequenti
          </h2>
          <p className="mt-4 text-[#0A0A0A]/65 text-lg">
            Tutto quello che vuoi sapere prima di iniziare.
          </p>
        </Reveal>

        <Reveal delay={80} className="mt-12">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((item, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                data-testid={`faq-item-${idx}`}
                className="border-b border-[#E0E0E0]"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${idx}`}
                  className="text-left text-[#0A0A0A] font-display font-semibold text-lg md:text-xl py-6 hover:no-underline hover:text-[#B40101] transition-colors duration-200"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${idx}`}
                  className="text-[#0A0A0A]/75 text-[16px] md:text-[17px] leading-relaxed pb-6 pr-4"
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
